import { render } from "./AccountOrderDetailsBackorderedItem.vue?vue&type=template&id=d345597a"
import script from "./AccountOrderDetailsBackorderedItem.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsBackorderedItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__